export default __webpack_public_path__ + "static/media/emaanamir.3edc4400.jpg";